import _ from 'lodash';

import { buildExpressionTree, normalizeAstKeys } from 'utils/expressions';
import { parseJSONObject } from 'utils/json';

/**
 * Parse the AST JSON returned by the BE `propose_final` tool call into
 * a normalized (camelCase) object tree. Returns null when the payload
 * is malformed so the caller can render a "preview unavailable" state
 * instead of throwing.
 */
export const parseProposedAst = expressionJson => {
  if (_.isEmpty(expressionJson)) {
    return null;
  }

  try {
    const parsed = parseJSONObject(expressionJson);

    if (_.isEmpty(parsed)) {
      return null;
    }

    return normalizeAstKeys(parsed);
  } catch {
    return null;
  }
};

/**
 * Parses a user-friendly expression (the value stored in the form
 * field) into a normalized AST. Returns null when the string is empty
 * or fails to parse so the caller can skip the diff and currentJson
 * payload without rendering an error.
 */
export const parseCurrentExpressionToAst = ({
  currentExpressionText,
  schemaParams,
  isOnlyBooleanAllowed,
  isNewExpressionsParsingLogicEnabled,
}) => {
  if (_.isEmpty(_.trim(currentExpressionText))) {
    return null;
  }

  try {
    const treeJson = buildExpressionTree(currentExpressionText, {
      schemaParams,
      isOnlyBooleanAllowed,
      isNewExpressionsParsingLogicEnabled,
    });

    if (_.isEmpty(treeJson)) {
      return null;
    }

    const parsed = parseJSONObject(treeJson);

    if (_.isEmpty(parsed)) {
      return null;
    }

    return { ast: normalizeAstKeys(parsed), json: treeJson };
  } catch {
    return null;
  }
};
